module.exports = __webpack_public_path__ + "media/application/images/icons/icon-farmer-97fd6742d1ef9ed56aba63d5fce2c426.svg";